exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  margin-top: 48px; }\n\nh6 {\n  margin: 0;\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/dashboard/dash-graphs/monthly-sales-by-cat/monthly-sales-by-cat.component.scss
// module id = ../../../../../src/app/views/dashboard/dash-graphs/monthly-sales-by-cat/monthly-sales-by-cat.component.scss
// module chunks = main